import { useEffect } from 'react';
/**
 * Synchronizes the map zoom level with the current zoom level
 * @param {{zoom: number, currentZoom: number, zoomAvailable: boolean, currentZoomAvailable: boolean, setZoom: Function}} param0
 */
export const useMapZoomSync = ({
    zoom,
    currentZoom,
    zoomAvailable,
    currentZoomAvailable,
    setZoom,
}) => {
    useEffect(() => {
        if (zoom === currentZoom || zoomAvailable || !currentZoomAvailable) return;
        setZoom(currentZoom);
    }, [currentZoom, currentZoomAvailable, setZoom, zoom, zoomAvailable]);
};
